<lx-selector-field-container
  i18n-label
  label="Course"
  [disabled]="disabled"
  [empty]="!selectedValue"
  [selectorFieldHandler]="openSelectorClickHandler"
  data-qa="onlineCourseSelector_field"
>
  {{ selectedValue ? selectedValue.name : emptySelectionMsg }}
</lx-selector-field-container>

<lx-side-panel i18n-title title="Select a course" size="large" [visible]="dialogVisible" (hiddenPanel)="hideDialog()" data-qa="onlineCourseSelector_sidePanel">
  <lx-online-course-selector
    [courseOptions]="courseOptions()"
    [initialSelectedCourse]="selectedValue"
    [currentDuration]="currentDuration"
    [currentStartDate]="currentStartDate"
    (selectedCourseChanged)="handleSelectedValue($event)"
    (predefinedSelectionsChanged)="handlePredefinedSelections($event)"
  >
  </lx-online-course-selector>
</lx-side-panel>
